import { useState } from "react";
import RoleList from "../Components/RoleList";
import RoleAdd from "../Components/RoleAdd";
import RolePermissionManager from "../Components/RolePermissionManager";
import PermissionList from "../Components/PermissionList";
import { usePermissionCheck } from "../hooks/usePermissionCheck";

export default function AdminPermissions() {
  const { loading, allowed } = usePermissionCheck("Permissions.View");
  const [tab, setTab] = useState("role-list");
  const [rolesReloadKey, setRolesReloadKey] = useState(0);

  if (loading) return <div className="p-8 text-center text-sm text-gray-500">Yetkiler kontrol ediliyor...</div>;
  if (!allowed) return <div className="p-8 text-center text-sm text-red-500">Bu sayfaya erişim iznin yok.</div>;

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Roller / İzinler</h1>
      <div className="flex gap-2">
        <button onClick={() => setTab("role-list")} className={`px-3 py-1 rounded text-sm ${tab === 'role-list' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}>Rol Listesi</button>
        <button onClick={() => setTab("role-add")} className={`px-3 py-1 rounded text-sm ${tab === 'role-add' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}>Rol Ekle</button>
        <button onClick={() => setTab("perm-manager")} className={`px-3 py-1 rounded text-sm ${tab === 'perm-manager' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}>Rol/İzin Yönetimi</button>
        <button onClick={() => setTab("perm-list")} className={`px-3 py-1 rounded text-sm ${tab === 'perm-list' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}>İzin Listesi</button>
      </div>

      {tab === "role-list" && <RoleList reloadKey={rolesReloadKey} />}
      {tab === "role-add" && <RoleAdd triggerReload={() => setRolesReloadKey((prev) => prev + 1)} />}
      {tab === "perm-manager" && <RolePermissionManager />}
      {tab === "perm-list" && <PermissionList reload={false} />}
    </div>
  );
}

